export default __webpack_public_path__ + "static/media/external-link-square.7766bf6d.svg";